import { hookstate } from "@hookstate/core";
import {
  InitResponsePayloadResults,
  ComicFacetGroupOptionEntity,
  ComicUserReadingStatusEntity,
} from "../services/gc/types";

export type AppState = {
  init: InitResponsePayloadResults;
  facetGroupMap: Record<number, ComicFacetGroupOptionEntity>;
  countryFlagMap: Record<string, string>;
  readingStatusMap: Record<number, ComicUserReadingStatusEntity>;
};

// Used for state that should be shared across screens
export const appStore = hookstate<AppState>({
  init: {} as InitResponsePayloadResults,
  facetGroupMap: {},
  countryFlagMap: {},
  readingStatusMap: {},
});
